import React, { useState } from 'react';
import { Box, Popover } from '@mui/material';
import { Sketch } from '@uiw/react-color';

interface ColorPickerProps {
    value?: string;
    defaultValue: string;
    onChange: (color: string) => void;
    label: string;
}

export function ColorPicker({ value, defaultValue, onChange, label }: ColorPickerProps) {
    const displayValue = value || defaultValue;
    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleColorChange = (color: any) => {
        onChange(color.hex);
    };

    return (
        <>
            <Box
                onClick={handleClick}
                sx={{
                    width: 40,
                    height: 40,
                    borderRadius: 1,
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: displayValue,
                    cursor: 'pointer',
                    flexShrink: 0,
                    '&:hover': {
                        opacity: 0.8,
                    },
                }}
                aria-label={label}
            />
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ p: 1 }}>
                    <Sketch
                        color={displayValue}
                        onChange={handleColorChange}
                    />
                </Box>
            </Popover>
        </>
    );
}

